import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { mergeMap, catchError, of } from 'rxjs'
import { CommonService } from 'src/app/services/common/common.service'
import { DashboardService } from 'src/app/services/dashboard/dashboard.service'
import { load_dashboard_state, load_dashboard_failure, load_dashboard_success } from '../action/dashboard.action'

@Injectable()
export class DashboardEffects {
  constructor(private actions$: Actions, private cs: CommonService, private dashboardService: DashboardService) {}

  loadUserDashboard$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(load_dashboard_state),
      mergeMap((action) =>
        this.dashboardService
          .getUserDashboard()
          .pipe(catchError((error: any) => of(load_dashboard_failure({ data: null, error: error }))))
      ),
      mergeMap((response) => [load_dashboard_success(response)])
    )
  })
}
